import { CONFIGURED_PROPERTIES_PRIORITY_ORDER } from '../constants/configuredProperties';
export const sortConfiguredTicketProperties = configuredTicketProperties => [...configuredTicketProperties].sort((a, b) => {
  // sorts priority order properties to front, then rest of configured properties by displayOrder
  const aPriority = CONFIGURED_PROPERTIES_PRIORITY_ORDER.includes(a.propertyName);
  const bPriority = CONFIGURED_PROPERTIES_PRIORITY_ORDER.includes(b.propertyName);
  if (aPriority !== bPriority) {
    return bPriority ? 1 : -1;
  } else if (aPriority && bPriority) {
    return CONFIGURED_PROPERTIES_PRIORITY_ORDER.indexOf(a.propertyName) - CONFIGURED_PROPERTIES_PRIORITY_ORDER.indexOf(b.propertyName);
  }
  // If neither have priority order, sort by displayOrder
  return a.displayOrder - b.displayOrder;
});